export enum Tenant {
  FLOTECH = 'flotech',
  FLEXPRINT = 'flextg',
  MARIMON = 'marimon',
  SANDBOX = 'sandbox',
}
